<div [ngClass]="{ 'activity-description__container': !iconOnly, 'activity-description__container--mobile': mobileListItem }"
     [@fadeIn]="activityState"
     (mouseover)="activityHovered()"
     (mouseleave)="activityUnhovered()"
     [id]="docId ? getActivityElementId() : null">
    <ohp-icon-font *ngIf="htmlDescription?.icon && showIcon"
                   [iconFontType]="htmlDescription.icon"
                   [size]="iconSize"
                   cssClass="ms-fcl-tp activity-icon {{iconCssClass}}"
                   [attr.aria-label]="htmlDescription?.activityDescription?.plainText">
    </ohp-icon-font>
    <ohp-person-picture *ngIf="!showIcon && person?.email"
                        [person]="person"
                        [personPictureCard]="true">
    </ohp-person-picture>
    <span *ngIf="htmlDescription?.html && !iconOnly"
          class="activity-description ms-fcl-ns"
          [ngClass]="{ 'activity-description--clipped' : numLines,
          'activity-description--card' : numLines === 2 && !fluentRefresh,
          'activity-description--card--fluent' : numLines === 2 && fluentRefresh,
          'activity-description--mobile': mobileListItem && numLines !== 2,
          'activity-description--motion-padding': !!title,
          'ms-fcl-ns': !fluentRefresh,
          'ms-fcl-nd': fluentRefresh }"
          #descriptionElement>
        <span [innerHTML]="htmlDescription.html"
              (mouseenter)="onHover()"
              [ngClass]="{ 'activity-deep-link ms-fcl-tp' : activityDeepLink && activityDeepLinkHovered, 'list-item__text--large activity-description__title--clipped ms-fcl-ns': !!title, 'activity-description--large': timestampAndTitleInSameLine }"
              title="{{ htmlDescription?.activityDescription?.plainText }}"></span>
        <div *ngIf="numLines === 2" class="activity-description__date"
             [ngClass]="{'activity-description__title--clipped': !!title, 'activity-description__date--fluent ms-fcl-npa': fluentRefresh}"
             title="{{ secondLine }}">
            {{ secondLine }}
            <span *ngIf="teamsDeepLink"> - </span>
            <span *ngIf="teamsDeepLink" [ngClass]="{ 'activity-deep-link__underlined ms-fcl-tp' : teamsDeepLink && activityDeepLinkHovered }">{{ inTeams }}</span>
        </div>
    </span>
</div>
<ng-container *ngIf="!htmlDescription">
    <ng-content></ng-content>
</ng-container>
